export class Name {
  constructor(
    public firstName?: string,
    public lastName?: string,
    public middleName?: string,
    public suffix?: string
  ) { }
}
